module.exports = __webpack_public_path__ + "img/game_item_礫間水質大作戰.3debf285.jpg";